import React, {useEffect} from 'react';
import Helmet from 'react-helmet';
import SEO from '../components/SEO';
import Layout from '../layouts/index';
import { DemoFormLong } from '../components/DemoFormLong.jsx';
import HtmlParser from 'html-react-parser';
import BasicHero from '../components/BasicHero'
import UserTestimonyCard from '../components/cards/UserTestimonyCard';
import ResponsiveSlider from '../components/ResponsiveSlider'
import BlogCard from '../components/cards/BlogCard';
import GuidesCard from '../components/cards/GuidesCard';
import HorizontalVideoCard from '../components/cards/HorizontalVideoCard';
import EBookCard from '../components/cards/EBookCard';
import { Link } from 'react-scroll';
import { PATHS } from '../utils/urls';


const Resources = (props) => {
	const location = props.location;

	return (
		<Layout  bodyClass="page-resources" ontouchstart>
			<SEO title="Resources | ChartHop | People Analytics, Visualized" />
			<Helmet>
				<meta
					name="description"
					content="A curation of blogs, videos, guides and case studies that will empower you to create data-informed organizational designs, headcount plans,  reports and more."
				/>
				<meta property="og:url" content={`https://www.charthop.com${location.pathname}`} />
				<meta property="og:title" content="Resources | ChartHop | People Analytics, Visualized" />
				<meta property="og:description" content="A curation of blogs, videos, guides and case studies that will empower you to create data-informed organizational designs, headcount plans,  reports and more." />
				<meta property="og:image" content={`https://www.charthop.com/home/meta-resources.png`} />
				<meta property="og:type" content="website" />
                <meta property="og:locale" content="en_US" />
        		<meta property="og:site_name" content="ChartHop" />
				{/* Twitter Card tags */}
				<meta name="twitter:title" content="Resources | ChartHop | People Analytics, Visualized" />
				<meta name="twitter:description" content="A curation of blogs, videos, guides and case studies that will empower you to create data-informed organizational designs, headcount plans,  reports and more." />
				<meta name="twitter:image" content={`https://www.charthop.com/home/meta-resources.png`} />
				<meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:site" content="@charthop" />
                <meta name="twitter:creator" content="@charthop" />

			</Helmet>

			{/* HERO CONTENT */}
            <section className="sectionSpacing">
                <BasicHero title="Resources" subtitle = "Create data-informed organizational designs, headcount plans, reports and more - with a little help from these resources. "/>
			</section>

            <section className="subNavigationMenu-Inline">
				<div>
					<div>
						<div className="navigation-element">
							<Link to="Guides-and-E-books" smooth={true} offset={-70} duration={500}>Guides & E-books</Link>
						</div>
						<div className="separator mobile-ml-5"><a>|</a></div>

						<div className="navigation-element">
							<Link to="Customer Stories" smooth={true} offset={-70} duration={500}>Customer Stories</Link>
						</div>
						<div className="separator even"><a>|</a></div>

						<div className="navigation-element">
							<Link to="Blog" smooth={true} offset={-70} duration={500}>Blog</Link>
						</div>
						<div className="separator"><a>|</a></div>
                    
                        <div className="navigation-element">
							<Link to="Videos" smooth={true} offset={-70} duration={500}>Videos</Link>
						</div>
						
					</div>
				</div>
			</section>

            {/* GUIDES & E-BOOKS */}
            <section className="text-center sectionSpacing flex-centeredColumn backgroundGradientContainer pb-5" id="Guides-and-E-books">
                <div className="contentBlock justify-content-between flex-wrap gridContainer">
                    <h2 className="text-center centerSpacing">Guides & E-Books</h2>                    
                    <ResponsiveSlider 
                        elements = {[
                            <GuidesCard
                            title="4 Building Block of Pay Equity"
                            urlImgDesktop="/resources/guides-ebooks/4-building-blocks/CH_4-building-blocks-thumbnail-landingpage_V1.png"
                            urlImgMobile="/resources/guides-ebooks/4-building-blocks/CH_4-building-blocks-thumbnail-landingpage_V1.png"
                            readMoreLink={PATHS.BUILDING_BLOCKS_PAY_EQUITY}
                            readMoreText="Download here"
                             />,    
                            <GuidesCard
                            title="3 Keys to Maintaining Culture During Massive Scale"
                            urlImgDesktop="/resources/guides-ebooks/3-keys/CH_3-Keys-to-Maintaining-Culture-thumbnail-landingpage_V1.png"
                            urlImgMobile="/resources/guides-ebooks/3-keys/CH_3-Keys-to-Maintaining-Culture-thumbnail-landingpage_V1.png"
                            readMoreLink={PATHS.KEYS_MAINTAINING_SCALE_MASSIVE_GROWTH}
                            readMoreText="Download here"
                            />,

                            <GuidesCard
                            title="2022 People Pioneers: Honoring HR Leaders Paving the Way Forward"
                            urlImgDesktop="/resources/guides-ebooks/people-pioneer/Thumb.png"
                            urlImgMobile="/resources/guides-ebooks/people-pioneer/Thumb.png"
                            readMoreLink={PATHS.PEOPLE_PIONEERS_2022}
                            readMoreText="Download here"
                             />,      
                            <GuidesCard
                            title="What to Do in Your First 90 Days as a Startup People Leader"
                            urlImgDesktop="/resources/guides-ebooks/startup-people-leader-checklist/headcount-planning-thumb.png"
                            urlImgMobile="/resources/guides-ebooks/startup-people-leader-checklist/headcount-planning-thumb.png"
                            readMoreLink={PATHS.STARTUP_PEOPLE_LEADER_CHECKLIST}
                            readMoreText="Download here"
                             />,
                            <GuidesCard
                            title="How to Confidently Approach Your 2022 Headcount Planning"
                            urlImgDesktop="/resources/guides-ebooks/headcount-planning-guide/headcount-planning-thumb.png"
                            urlImgMobile="/resources/guides-ebooks/headcount-planning-guide/headcount-planning-thumb.png"
                            readMoreLink={PATHS.HEADCOUNT_PLANNING_GUIDE}
                            readMoreText="Download here"
                             />,
                            <GuidesCard
                            title="A Startup's Guide to Intentional Growth"
                            urlImgDesktop="/resources/guides-ebooks/Guide-to-intentional-Growth-thumb.png"
                            urlImgMobile="/resources/guides-ebooks/Guide-to-intentional-Growth-thumb.png"
                            readMoreLink={PATHS.STARTUPS_INTENTIONAL_GROWTH}
                            readMoreText="Download here"
                             />,
                            <GuidesCard
                            title="Setting Remote Salaries"                                                                
                            urlImgDesktop="/resources/guides-ebooks/remote-salaries@2x.png"
                            urlImgMobile="/resources/guides-ebooks/remote-salaries@2x.png"
                            readMoreLink={PATHS.REMOTE_WORK_SALARIES}
                            readMoreText="Download here"
                            />,
                            <GuidesCard
                            title="Comprehensive DEI Reporting"
                            urlImgDesktop="/resources/guides-ebooks/dei-reporting@2x.png"
                            urlImgMobile="/resources/guides-ebooks/dei-reporting@2x.png"
                            readMoreLink={PATHS.DEI_REPORTING}
                            readMoreText="Download here"
                             />,
                             <GuidesCard 
                            title="Return to Office Surveys" 
                            urlImgDesktop="/resources/guides-ebooks/returntoworkupdate-thumbnail-desktop.png"
                            urlImgMobile="/resources/guides-ebooks/returntoworkupdate-thumbnail-desktop.png"
                            readMoreLink={PATHS.RETURN_TO_WORK}
                            readMoreText="Download here"
                             />,
                            <GuidesCard 
                                title="Charting Better Workplaces: 2020 Report"
                                urlImgDesktop="/resources/guides-ebooks/compensation-data-report-2020-cover.png"
                                urlImgMobile="/resources/guides-ebooks/compensation-data-report-2020-cover.png"
                                readMoreLink={PATHS.CHARTING_BETTER_WORKPLACES_2020}
                                readMoreText="Download here"
                            />,
                           
                           
                            <GuidesCard
                                title="Offering Equitable Compensation"
                                urlImgDesktop="/resources/guides-ebooks/equitable-comp@2x.png"
                                urlImgMobile="/resources/guides-ebooks/equitable-comp@2x.png"
                                readMoreLink={PATHS.FAIR_EQUITABLE_COMPENSATION}
                                readMoreText="Download here"
                            />,
                           
                            <GuidesCard
                                title="Charting Better Galaxies: The April Fools' Report"
                                urlImgDesktop="/resources/guides-ebooks/astrology-april-fools-campaign-resources-desktop.png"
                                urlImgMobile="/resources/guides-ebooks/astrology-april-fools-campaign-resources-desktop.png"
                                readMoreLink={PATHS.CHARTING_BETTER_GALAXIES}
                                readMoreText="Download here"
                            />    
                        ]}
                    />
                </div>
                <div className="sectionSpacing"> </div>            
            </section>

			{/* CUSTOMER STORIES */}
            <section className="text-left flex-centeredColumn sectionSpacing pb-5" id="Customer Stories">
            <h2 className="text-center centerSpacing">Customer Stories</h2>
            <div className="contentBlock d-flex justify-content-between flex-wrap gridContainer">            

            <div className="backgroundGradientContainer-Reverse">
            <UserTestimonyCard 
                testimony={<p>
                    <p>"With a fully-distributed growing team, it can be challenging to understand how our organization has evolved and how teams are structured. Thanks to ChartHop's auto-updated org chart , we can easily find our coworkers and reach out to them seamlessly via email or Slack.</p>
                    <p>Being able to visualize the org chart by any dimension (department, time, zone, gender, squad) has <strong>empowered</strong> my team to make more <strong>strategic people decisions</strong>. Plus, the org chart being fully integrated with our HRIS makes for seamless updates and <strong>zero manual work </strong> for my team.</p>
                    <p>Now, all of our employees can login to ChartHop and see the org structure, how the team is growing and even where their coworkers are on the map"</p>
                    </p>}
                logo="/resources/customer-stories/invision-logo.png"
                logoAlt="InVision"
                name="Shelby Wolpa"
                readMoreButton={false}
                position="VICE PRESIDENT OF PEOPLE OPERATIONS"
                image="/customers/customer-stories/thumbnails/shelby-wolpa@2x.png"
                imbalanced={true}
            />
            </div>

            <div className="backgroundGradientContainer margin-cards"> 
            <UserTestimonyCard
                testimony={<p>
                    <p>"ChartHop helped us replace our <strong>mundane, outdated processes.</strong></p>
                    <p>With the auto-updated org chart, custom reporting, and real-time scenario-building, ChartHop has been a critical tool in my organization's <strong>succession planning </strong> and <storng>data comprehension.</storng></p>
                    <p>Now I can blueprint my organizational changes and understand budget impact - <strong>all in one place</strong></p>
                    <p>ChartHop will help you more <strong>efficiently</strong> look at and <strong> analyze </strong> your organization. I can't imagine what we'd do without it."</p>
                    </p>}
                logo="/customers/customer-stories/logos/png/remy-cointreau.png"
                logoAlt="remy-cointreau"
                name="David Dankenbrink"
                readMoreButton={false}
                position="VICE PRESIDENT, HUMAN RESOURCES"
                image="/customers/customer-stories/thumbnails/david-dankenbrink@2x.png"
            />

            </div>

            </div>
            <div className="buttonContent mt-5">
				<center><a className="button" rel="noopener noreferrer" target="_blank" href={PATHS.CUSTOMER_STORIES}>CHECK OUT MORE CUSTOMER STORIES</a></center>
			</div>

            </section>
            
			{/* BLOGS */}
            <section className="text-center sectionSpacing flex-centeredColumn backgroundGradientContainer pb-5" id="Blog">
            <div className="contentBlock justify-content-between flex-wrap gridContainer">
            <h2 className="text-center centerSpacing">Blog</h2>
            
            <ResponsiveSlider 
                elements = {[
                    <BlogCard
                        urlImg="/blog/best-practices/continuous-performance-management-employee-development/slider-image.png"
                        title="Continuous Performance Management is the future of employee development"
                        description={<p>What is Continuous Performance Management and what makes it such an effective evaluative tool?<br/> Learn how you can implement it in your organization.</p>}
                        link="/blog/best-practices/continuous-performance-management-employee-development/"
                        cta="here"
                        footer="Read more "
                        subtitle="BEST PRACTICES"
                        cardColor ="#FFFFFF"
                    />,
                    <BlogCard
                        urlImg="/blog/product-updates/new-slack-integration/slider-image.png"
                        title="Increase alignment and transparency with the new Slack + ChartHop integration"
                        description={<p>Increase alignment and transparency with the new Slack + ChartHop integration.<br/> With custom and flexible notifications, teams can be kept up to date of any changes. </p>}
                        link="/blog/product-updates/charthop-new-slack-integration/"
                        cta="here"
                        footer="Read more "
                        subtitle="PRODUCT UPDATES"
                        cardColor ="#FFFFFF"
                    />,
                    <BlogCard
                        urlImg="/blog/best-practices/managing-remote-employees/slider-image.png"
                        title="3 tips for managing remote employees"
                        description={<p>The key to remote work productivity is connection and collaboration.<br/> Ian White, founder & CEO, shares how managers can empower employees to complete their work with autonomy.</p>}
                        link="/blog/best-practices/managing-remote-employees/"
                        cta="here"
                        footer="Read more "
                        subtitle="BEST PRACTICES"
                        cardColor ="#FFFFFF"
                    />,
                    <BlogCard 
                        urlImg="/blog/best-practices/people-ops-contingency-planning/slider-image.png"
                        title = "How People Ops can navigate crises with contingency planning"
                        description={<p>Input from People Ops is essential to drive effective planning.<br/> Use this three-step framework to create contingency plans for serious people ops risks.</p>}
                        link="/blog/category/best-practices/people-ops-contingency-planning/"
                        cta="here"
                        footer="Read more "
                        subtitle="BEST PRACTICES"
                        cardColor ="#FFFFFF"
                    />,
                    <BlogCard 
                        urlImg="/blog/best-practices/span-of-control-free-calculator/slider-image.png"
                        title="What’s a manageable span of control? (+ free calculator)"
                        description={<p>Understand the importance of span of control, the pros and cons of wide and narrow spans and use a new framework to calculate a role's ideal span of control.</p>}
                        link="/blog/best-practices/span-of-control-free-calculator/"
                        cta="here"
                        footer="Read more "
                        subtitle="BEST PRACTICES"
                        cardColor ="#FFFFFF"
                    />,
                    <BlogCard
                        urlImg="/blog/product-updates/new-okta-integration/slider-image.png"
                        title="Set up SSO and Automate App Provisioning with New Okta Integration"
                        description={<p>Give employees access to needed resources with the ChartHop and Okta integration.  <br/> Streamline app provisioning and provide secure access to ChartHop via SSO.</p>}
                        link="/blog/product-updates/charthop-new-okta-integration/"
                        cta="here"
                        footer="Read more "
                        subtitle="PRODUCT UPDATES"
                        cardColor ="#FFFFFF"
                    />
            ]}/>
            </div>
    
            
            <div className="sectionSpacing"> </div>
            <div className="buttonContent cta-blog">
				<center><a className="button" rel="noopener noreferrer" target="_blank" href={PATHS.BLOG}>CHECK OUT THE BLOG</a></center>
			</div>
            </section>

            {/* VIDEOS */}

            <section className="sectionSpacing pb-5 flex-centeredColumn" id="Videos">                
                <h2 className="text-center centerSpacing">Videos</h2>
                <div className="contentBlock d-flex justify-content-between flex-wrap gridContainer">

                <HorizontalVideoCard 
                    imgUrl="/resources/videos/introducing-charthop@2x.png"
                    title="Introducing ChartHop"
                    description="Using the ChartHop platform, decision-makers can visualize, plan and analyze their organization within minutes through self-updating org charts, custom reporting, and headcount planning tools that boost alignment and transparency."
                    readMoreLink="/resources/videos/introducing-charthop/"
                    readMoreText="Watch here"
                    cardColor="-Reverse"
                /> 

                <HorizontalVideoCard 
                    imgUrl="/resources/videos/greenhouse-integration@2x.png"
                    title="ChartHop + Greenhouse Integration"
                    description="ChartHop Scenarios empower you to create plans for the future. With the ChartHop + Greenhouse integration, you can take those plans and put them into action."
                    readMoreLink="/resources/videos/charthop-greenhouse-integration/"
                    readMoreText="Watch here"
                    cardColor="-Reverse"
                /> 

                <HorizontalVideoCard 
                    imgUrl="/resources/videos/charthop-scenarios@2x.png"
                    title="Introduction to ChartHop Scenarios"
                    description="Scenarios were created to streamline the planning processes and give stakeholders one platform to create, approve, execute, and most importantly, iterate on headcount plans as business conditions change."
                    readMoreLink="/resources/videos/scenarios/"
                    readMoreText="Watch here"
                    cardColor="-Reverse"
                />

                </div>
                <div className="buttonContent mt-2">
					<center><a className="button" rel="noopener noreferrer" target="_blank" href="/resources/videos/">CHECK OUT MORE VIDEOS</a></center>
				</div>
            </section>


			{/* LONG FORM */}
			<section name="request-demo" id="request-demo" className="request-demo sectionSpacing">
                <DemoFormLong source={"resources-demo-bottom"} headertext={HtmlParser("<h2>We'd love to show you what we're building.</h2><h2>Request a demo!</h2>")}/>
            </section>
		</Layout>
	);
};


export default Resources;